export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/taco.d049b3eb.svg","height":11,"width":14};